// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-qanda {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  min-height: 100vh;
}
.public-qanda__question {
  flex-grow: 1;
}
.public-qanda > *:last-child {
  margin-top: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/PublicQandA/PublicQandA.scss"],"names":[],"mappings":"AAAA;EACI,OAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,iBAAA;AACJ;AACI;EACI,YAAA;AACR;AAEI;EACI,gBAAA;AAAR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
